import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    login({ name: 'Student', email: 'student@studentencity.nl' });
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-20">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <h1 className="text-3xl font-bold text-center mb-8">Inloggen</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">E-mail</label>
            <input type="email" className="w-full px-4 py-3 border rounded-lg" placeholder="jouw@email.nl" required />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 mb-2">Wachtwoord</label>
            <input type="password" className="w-full px-4 py-3 border rounded-lg" placeholder="••••••••" required />
          </div>
          <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-bold hover:shadow-lg transition">
            Inloggen
          </button>
        </form>
        <p className="text-center mt-6 text-gray-600">
          Nog geen account? <Link to="/register" className="text-blue-600 font-semibold">Aanmelden</Link>
        </p>
      </div>
    </div>
  );
}
